import clone from 'lodash.clonedeep';

import { toCardLabel, toImageUrl } from '../utils/format.util';

export default class CardsService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getCard(id) {
    const doc = await this.firebase.firestore()
      .collection('cards')
      .doc(id)
      .get();

    if (!doc.exists) {
      return null;
    }

    const card = {
      id: doc.id,
      ...doc.data(),
      dateAdded: typeof doc.data().dateAdded === 'object' ? doc.data().dateAdded.toDate() : null,
      newestSaleDate: doc.data().stats && doc.data().stats.newestSale && typeof doc.data().stats.newestSale.date === 'object' ? doc.data().stats.newestSale.date.toDate() : null,
    };

    if (card.stats && card.stats.newestSale && card.stats.newestSale.date && typeof card.stats.newestSale.date.toDate === 'function') {
      card.stats.newestSale.date = card.stats.newestSale.date.toDate();
    }

    if (!card.multipliers) {
      card.multipliers = [];
    }

    return card;
  }

  async createOrUpdate(card) {
    const cardToSave = clone(card);

    delete cardToSave.id;

    cardToSave.image = typeof card.image === 'string' ? card.image : '';
    cardToSave.label = toCardLabel(card);

    let { id } = card;

    if (card.id) {
      await this.firebase.firestore()
        .collection('cards')
        .doc(card.id)
        .update(cardToSave);
    } else {
      cardToSave.dateAdded = new Date();
      cardToSave.hidden = true;
      cardToSave.status = 'progress';

      const doc = await this.firebase.firestore()
        .collection('cards')
        .add(cardToSave);

      id = doc.id;
    }

    if (card.image && (card.image.name || card.image.size)) {
      const path = `cards/${id}`;
      const imageRef = this.firebase.storage().ref().child(path);
      await imageRef.put(card.image);

      await this.firebase.firestore()
        .collection('cards')
        .doc(id)
        .update({
          image: toImageUrl(path),
        });
    }

    return id;
  }

  async updateNeedsReview(id, needsReview) {
    return this.firebase.firestore()
      .collection('cards')
      .doc(id)
      .update({
        needsReview: needsReview ? true : this.firebase.firestore.FieldValue.delete(),
      });
  }

  async admitCardsInReview(cardIds) {
    if (cardIds.length === 0 || cardIds.length > 500) {
      return;
    }

    const batch = this.firebase.firestore().batch();

    cardIds.forEach((cardId) => {
      batch.update(this.firebase.firestore().collection('cards').doc(cardId), {
        hidden: false,
        status: this.firebase.firestore.FieldValue.delete(),
        adminNotes: this.firebase.firestore.FieldValue.delete(),
        dateAdded: new Date(),
      });
    });

    await batch.commit();
  }

  async updateCardStatuses(cardIds, status) {
    if (cardIds.length === 0 || cardIds.length > 500) {
      return;
    }

    const batch = this.firebase.firestore().batch();

    cardIds.forEach((cardId) => {
      batch.update(this.firebase.firestore().collection('cards').doc(cardId), {
        status,
      });
    });

    await batch.commit();
  }

  async deleteCard(cardId, uid) {
    await this.firebase.firestore()
      .collection('cards')
      .doc(cardId)
      .update({
        uid,
      });

    return this.firebase.firestore()
      .collection('cards')
      .doc(cardId)
      .delete();
  }

  async deleteCards(cardIds) {
    if (cardIds.length === 0 || cardIds.length > 500) {
      return;
    }

    const batch = this.firebase.firestore().batch();

    cardIds.forEach((cardId) => {
      batch.delete(this.firebase.firestore().collection('cards').doc(cardId));
    });

    await batch.commit();
  }
}
